import { themeQuartz } from 'ag-grid-community';

export const theme = themeQuartz.withParams({
  browserColorScheme: 'light',
  columnBorder: true,
  fontFamily: 'inherit',
  headerFontSize: 14,
  headerFontWeight: 600,
  headerBackgroundColor: 'white',
  cellHorizontalPadding: 16,
});

export const ADD_ROW_KEY = '_add';
export const DELETE_ROW_KEY = '_delete';
export const TOTAL_ROW_KEY = '_total';
export const DEFAULT_ROW_KEY_COL_NAME = 'id';
export const SOV_PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 500, 1000];
